/**
 * @typedef {Object} PonticDO
 * @property {number} stageNumber - The stage number
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} ponticNum - The number of the pontic
 * @property {string} fileUrl - URL of the tooth file
 * @property {string} fileType - Type/extension of the file
 * @property {string} filePath - Full file path
 */

/**
 * @type {PonticDO[]}
 */
const ponticDOListSingle = [];

/**
 * @param {PonticDO} ponticDO
 */
const addPonticDO = (ponticDO) => {
  ponticDOListSingle.push(ponticDO);
};

const getPonticDOList = () => {
  return ponticDOListSingle;
};

export default {
  addPonticDO,
  getPonticDOList,
};
